export class CreateSectorIdUseCase{
  constructor(repository,sectorHasSoilrepository,sectorHasFarmrepository) {
    this.repository = repository
    this.sectorHasSoilRepository= sectorHasSoilrepository
    this.sectorHasFarmRepository= sectorHasFarmrepository
  }
  async execute(sector){
    const {ID_SECTOR,ID_FARM,ID_SOIL}=sector
    //Sempre que salvar os dados irá buscar no banco de CAD_SECTOR (NEWSIR)
    // se esse dado já existe.
    const cad_sector_newsir=await this.repository.getSectorFromNewsirById(ID_SECTOR)

    const resp=await this.repository.save(sector,cad_sector_newsir)
    //Pegar o setor recem cadastrado no CROP
    const data= await this.repository.showBySectorId(ID_SECTOR)
    if(data && data[0].length){
      //Lembrando que esse ID não é o ID do setor e sim ID tabela CAD_SECTOR de CROP
      await this.sectorHasFarmRepository.save(data[0][0].ID,ID_FARM)
      await this.sectorHasSoilRepository.save(data[0][0].ID,ID_SOIL)

    }

    return resp
  }
}
